<template>
  <div>
    <div class="card">
      <div class="headerParent d-flex align-items-center justify-content-end">
        <button @click="addNewSection" class="btn btn-outline-secondary">+ اضافه کردن بخش</button>
        <button @click="addNewQuestion" class="primary__button">+ اضافه کردن سوال</button>
      </div>
    </div>

    <div class="card">
      <draggable :group="{ name: 'headline', put: false }" :list="examination.questions" :swapThreshold="1" :animation="200" direction="vertical">
        <div v-for="(exam, index) in examination.questions" :key="index" style="cursor: pointer">
          <div class="mainSection" @click="setActiveIndex(index)">
            <div class="sectionHeader">
              <BaseText
                v-model="exam.title"
                @focused="setActiveIndex(index)"
                title="عنوان بخش"
                placeholder="عنوان بخش"
                required
                :showError="sectionHeaderError"
                errortext="وارد کردن این فیلد الزامی است"
              />
            </div>

            <div @click="setSectionActiveIndex(index)" class="subSectionContainer">
              <div class="add__remove__container">
                <div @click="addAnItem(exam, index)" class="plus__container">
                  <i class="fa fa-plus"></i>
                </div>
                <div @click="removeItem(exam)" class="minus__container">
                  <i class="fa fa-minus"></i>
                </div>
              </div>
              <div class="change__sort__button">
                <div @click="sortUp(index)" class="change__sort">
                  <i class="fas fa-caret-up"></i>
                </div>
                <div @click="sortDown(index)" class="change__sort">
                  <i class="fas fa-caret-down"></i>
                </div>
              </div>
              <b-dropdown size="lg" variant="link" toggle-class="text-decoration-none" no-caret>
                <template #button-content>
                  <div class="dropdownButton d-flex justify-content-between align-items-center">
                    <div>{{ exam.questionType === 0 ? 'تک انتخابی' : 'چند انتخابی' }}</div>

                    <i style="color: #74788d" class="fas fa-caret-down"></i>
                  </div>
                </template>

                <b-dropdown-item @click="changeSectionContent(index, 0)">تک انتخابی</b-dropdown-item>

                <b-dropdown-item @click="changeSectionContent(index, 1)">چند انتخابی</b-dropdown-item>
              </b-dropdown>

              <div class="w-100 ps-3">
                <RadioSelection
                  :questions="exam"
                  @addRadioOptionClick="onRadioOptionClick(index)"
                  @removeRadioFieldIndex="onRemoveRadioFieldIndex"
                  @checkRadioInput="onCheckRadioInput"
                  @sectionNameChange="onSectionNameChange"
                />
              </div>
            </div>
          </div>
        </div>
        <Toast :title="toastText" :submit="toastMode" :showToast="showToast" />
      </draggable>
    </div>
    <div class="footer__parent d-flex justify-content-end align-items-center">
      <Button @click.native="addLine" text="انصراف" btnClass="btn-border cancel" />
      <Button @click.native="submit()" text="ثبت" btnClass="ms-2 approve btn-border" :loading="btnLoading" />
    </div>
  </div>
</template>

<script>
import BaseText from '../../../components/common/form/formModules/BaseText.vue'
import Button from '../../../components/common/Button.vue'
import Toast from '../../../components/common/Toast.vue'
import RadioSelection from './RadioSelection.vue'
import moocExaminationServices from '../../../services/mooc/examination'
import draggable from 'vuedraggable'

export default {
  components: {
    BaseText,
    RadioSelection,
    Button,
    Toast,
    draggable,
  },
  data() {
    return {
      correctAnswer: '',
      btnLoading: false,
      examination: {
        courseSessionFileId: this.$route.query.fileId,
        questions: [],
      },

      activeIndex: undefined,
      sectionActiveIndex: null,
      toggleItems: true,
      componentsCount: 0,
      toggleMainDiv: true,
      radioComponentKey: 1,
      toggleInputKey: 1,
      isEdited: true,
      toastText: '',
      toastMode: false,
      showToast: null,
      sectionHeaderError: false,
    }
  },
  props: {
    courseSessionFileId: { type: Number, required: true },
  },
  methods: {
    addLine() {
      this.$emit('addLine')
    },
    onSectionNameChange(payload) {
      this.examination.questions[this.activeIndex].questionText = payload
      console.log(this.examination)
    },
    onRadioOptionClick(index) {
      this.examination.questions[index].answers.push({
        title: '',
        id: undefined,
        isCorrect: false,
        order: this.examination.questions[index].answers.length,
      })
    },
    onRemoveRadioFieldIndex(index) {
      setTimeout(() => {
        let exam = this.examination.questions[this.activeIndex]
        exam = exam.answers.splice(index, 1)
      }, 1000)
    },
    onCheckRadioInput(event, index) {
      this.examination.questions[this.activeIndex].answers[index].isCorrect = ['true', true].includes(event) ? true : false
    },
    async getExamination() {
      try {
        const req = await moocExaminationServices.getExamination(this.$route.query.fileId || this.courseSessionFileId)
        if (req.status === 200) this.examination = req.data.data.output
      } catch (error) {
        console.log(error)
      }
    },

    submit() {
      if (!this.examination.questions.length) return
      this.btnLoading = true
      this.btnLoading = false
      if (this.examination.questions[this.activeIndex].id) {
        this.editExam()
      } else this.addNewExamination()
    },
    async editExam() {
      try {
        const payload = {
          courseSessionFileId: this.examination.courseSessionFileId,
          questions: [this.examination.questions[this.activeIndex]],
        }
        const req = await moocExaminationServices.editExam(payload)
        if (req.status === 200) {
          this.toastText = 'تغییرات با موفقیت ذخیره شد.'
          this.toastMode = true
          this.showToast = true
          this.getExamination()
        }
      } catch (error) {
        console.log(error)
      }
    },
    async addNewExamination() {
      const question = this.examination.questions.filter((ex) => !ex.hasOwnProperty('id'))
      const payload = {
        courseSessionFileId: this.examination.courseSessionFileId,
        questions: question,
      }
      try {
        const req = await moocExaminationServices.addExam(payload)
        if (req.status === 200) {
          this.toastText = 'با موفقیت ذخیره شد.'
          this.toastMode = true
          this.showToast = true
        }
        this.getExamination()
      } catch (error) {
        console.log(error)
      }
    },
    changeSectionContent(index, type) {
      this.examination.questions[index].answers.forEach((item) => (item.isCorrect = false))
      if (type === 0) {
        this.examination.questions[index].questionType = 0
      } else this.examination.questions[index].questionType = 1
    },
    setActiveIndex(payload) {
      this.activeIndex = payload
    },
    setSectionActiveIndex(payload) {
      this.sectionActiveIndex = payload
    },
    addNewQuestion() {
      this.examination.questions.push({
        questionText: '',
        questionType: 1,
        order: this.examination.questions.length,
        answers: [
          {
            title: '',
            isCorrect: false,
            order: 0,
          },
          {
            title: '',
            isCorrect: false,
            order: 1,
          },
        ],
      })
    },
    addNewSection() {
      this.examination.questions.push({
        questionText: '',
        questionType: 1,
        order: this.examination.questions.length,
        answers: [
          {
            title: '',
            isCorrect: false,
            order: 0,
          },
          {
            title: '',
            isCorrect: false,
            order: 1,
          },
        ],
      })
    },

    sortUp(index) {
      if (index === 0) return
      else {
        this.examination.questions[index - 1].order = this.examination.questions[index - 1].order + 1
        this.examination.questions[index].order = this.examination.questions[index].order - 1
        this.examination.questions.sort((a, b) => a.order - b.order)
      }
    },
    sortDown(index) {
      if (index === this.examination.questions.length - 1) return
      else {
        this.examination.questions[index].order = this.examination.questions[index].order + 1
        this.examination.questions[index + 1].order = this.examination.questions[index + 1].order - 1
        this.examination.questions.sort((a, b) => a.order - b.order)
      }
    },
    removeItem(exam) {
      const index = this.examination.questions.indexOf(exam)
      if (index > -1) this.examination.questions.splice(index, 1)
      // this.examination.questions[childIndex].questionType.splice(childIndex, 1)
    },
    addAnItem(payload, index) {
      console.log(payload)
      const answers = this.getAnswerPayload(payload)
      this.examination.questions.splice(index + 1, index, { answers: answers, questionType: this.examination.questions[index].questionType })
    },
    getAnswerPayload(array) {
      let answers = []
      for (let index = 0; index < array.answers.length; index++) {
        answers.push({ isCorrect: undefined, order: index, title: '' })
      }

      return answers
    },
  },
  async mounted() {
    await this.getExamination()
  },
}
</script>

<style lang="scss" scoped>
.headerParent {
  background: white;
  padding: 20px;
  border-radius: 3px;
}
.btn-border {
  border-radius: 4px !important;
}
.approve {
  background-color: #556ee6 !important;
}
.cancel {
  background-color: rgba(51, 51, 51, 0.6) !important;
}

.mainSection {
  border: 1px solid #f0f1f1 !important;
  border-radius: 5px;
}
.sectionHeader {
  padding: 30px;
  border-radius: 5px 5px 0 0;
  background: #f8f9fa;
}
.subSectionContainer {
  padding: 30px;
  border-bottom: 1px solid #eaeaea;
  display: flex;
  align-items: flex-start;
  position: relative;
}
.subSectionContainer:last-child {
  border-radius: 5px;
}
.dropdownButton {
  background: #ffffff;
  border: 1px solid #ced4da;
  box-sizing: border-box;
  border-radius: 4px;
  width: 200px;
  height: 32px;
  padding-right: 20px;
  padding-left: 12px;
}
::v-deep .dropdown-toggle {
  padding: 0 !important;
  color: #444444 !important;
  font-size: 12px !important;
}

.secondary__button {
  padding: 8px 18px;
  color: white;
  background: #74788d;
  border-radius: 5px;
  font-size: 13px;
}
.primary__button {
  background-color: #556ee6;
  padding: 8px 18px;
  box-shadow: none;
  color: white;
  border-radius: 5px;
  font-size: 13px;
  margin-right: 10px;
}
.footer__parent {
  margin-bottom: 20px;
}
.activeSubSection {
  background: #f8f9fa;
  border-top: 1px dashed #ced4da;
  border-bottom: 1px dashed #ced4da;
  &:last-child {
    border-bottom: none;
  }
}
.add__remove__container {
  position: absolute;
  left: -10px;
  top: 50%;
  transform: translateY(-50%);
}
.plus__container {
  background: #34c38f;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  margin-bottom: 10px;
  i {
    color: white;
  }
}
.minus__container {
  background: #ff4861;
  padding: 0 3px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  i {
    color: white;
  }
}
.change__sort__button {
  position: absolute;
  right: -7px;
  top: 50%;
  transform: translateY(-50%);
}
.change__sort {
  background: #74788d;
  padding: 5px 3px;
  display: flex;
  justify-content: center;
  align-items: center;
  i {
    color: white;
    font-size: 10px;
  }
}
.alert.alert-popUp.alert-dismissible.alert-info {
  padding: 0;
}
</style>
